import core from '@gin-betting/core';
import { createSelector } from 'reselect';

const {
    entities: {
        selectors: { selectOdd, selectMarket, selectMatch },
    },
} = core;

export const selectEntitiesData = createSelector(
    selectOdd,
    selectMarket,
    selectMatch,
    (odd, market, match) => {
        if (!odd || !market || !match) {
            return { marketName: '', oddName: '', matchStatus: null };
        }

        return {
            oddName: odd.name,
            marketName: market.name,
            matchStatus: match.status,
        };
    }
);
